import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as yup from "yup";
//redux
import { useDispatch, useSelector } from "react-redux";
import { getContactData, sendContactData } from "../../redux/page/pageActions";
//MUI
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
//Icons
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import PhoneEnabledIcon from "@material-ui/icons/PhoneEnabled";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
//Components
import WideLayout from "../../layouts/WideLayout";
import * as TextLoader from '../../components/StaticTexts/Index'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "normal",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    textColorDark: {
        color: "#3B3B3B",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    grayBoxWithTitle: {
        backgroundColor: "#f2f2f2",
        marginTop: "-5px",
        borderRadius: "10px",
        [theme.breakpoints.up("sm")]: {
            padding: "45px 5px 40px 5px",
        },
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        width: "140px",
        "&:hover": {
            background: "#447557",
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '16px',

        },
        [theme.breakpoints.up('sm')]: {
            marginLeft: '0px',
            marginBottom: '0px',
        }
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    padding16OnDesktop: {
        [theme.breakpoints.up('sm')]: {
            paddingRight: '16px',
            paddingLeft: '16px',
        }
    },
    formC: {
        [theme.breakpoints.down('sm')]: {
            padding: '8px 16px 16px 16px'
        },
        [theme.breakpoints.up('sm')]: {
            padding: '16px'
        }
    },
    btnC: {
        [theme.breakpoints.down('sm')]: {
            padding: '16px',
            marginBottom: '20px',
            marginLeft: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            padding: '32px',
        }
    },
    emailC: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '8px',
        },
    }
}));

const ContactUs = ({ lang }) => {


    const classes = useStyles();
    const dispatch = useDispatch();
    const [loading, setLoadeing] = useState(true);
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    const [validationSchema, setValidationSchema] = useState()
    const [staticText, setStaticText] = useState({})
    const data = useSelector((state) => state.contactData);
    const sending = useSelector((state) => state.contactMsg);
    const { msg } = sending

    const [breadcrumbsItems, setBreadcrumbsItems] = useState([]);

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const toggleOpenAlert = (Type, msgs) => {
        setAlert({
            open: true,
            type: Type,
            message: msgs,
        });
    };

    const { address, phoneNumbers, workTime, email } = data;
    const variants = ["caption", "caption", "caption", "caption"];

    useEffect(() => {
        dispatch(getContactData(lang)).then(() => setLoadeing(false));
        if (lang === 'fa') {
            setValidationSchema(yup.object({
                FullName: yup
                    .string("لطفا نام و نام خانوادگی خود را وارد کنید")
                    .required("نام و نام خانوادگی الزامی است"),
                MobileNumber: yup
                    .string("شماره موبایل خود را وارد کنید")
                    .required("شماره موبایل الزامی می باشد.")
                    .matches(/^[0-9]+$/, "شماره تلفن باید عدد باشد.")
                ,
                Text: yup
                    .string("لطفا پیام خود را وارد کنید.")
                    .required("وارد کردن متن پیام الزامی می باشد.")
                    .min(10, ' حداقل طول متن  10 کاراکتر می باشد.')
                    .max(160, ' حداکثر طول متن  160 کاراکتر می باشد.'),
            }))
            setBreadcrumbsItems([
                {
                    title: 'صفحه اصلی',
                    to: "/"
                },
                {
                    title: 'تماس با ما',
                    to: "/contactUs"
                }
            ])
        }
        else {
            setValidationSchema(yup.object({
                FullName: yup
                    .string("الرجاء إدخال الاسم الأول والأخير ")
                    .required("الاسم واللقب مطلوبان"),
                MobileNumber: yup
                    .string("أدخل رقم هاتفك المحمول ")
                    .required("رقم الهاتف المحمول مطلوب")
                    .matches(/^[0-9]+$/, "يجب أن يكون رقم الهاتف رقمًا. ")
                ,
                Text: yup
                    .string("أدرج رسالتك من فضلك.")
                    .required("أدخل نص الرسالة مطلوب.")
                    .min(10, 'الحد الأدنى لطول النص هو 10 أحرف.')
                    .max(160, 'الحد الأقصى لطول النص هو 160 حرفًا.'),
            }))
            setBreadcrumbsItems([
                {
                    title: 'الصفحة الأصلية',
                    to: "/"
                },
                {
                    title: 'اتصل بنا',
                    to: "/contactUs"
                }
            ])
        }
        setStaticText(TextLoader.staticTextLoader("contactUs", lang))
    }, [dispatch]);

    return (
        <>
            <WideLayout lang={lang} breadcrumbsItems={breadcrumbsItems} title="تماس با ما | آجیل حسن پور"
                metas={{
                    keywords: "پسته ,فندق,آجیل , عید , پاستیل , زعفران , شیرینی , آلوچه ,لواشک ,بادام , مغز ,مغز گردو ,گردو , تخمه , پشمک , شکلات ,ماش ,لوبیا ",
                    description: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
                    subject: "nuts",
                    copyright: 'Ajilhassanpour',
                    language: lang,
                    robots: "index,follow",
                    abstract: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
                    topic: 'nuts',
                    summary: 'آجیل حسن پور ',
                    Classification: 'E-COMMERCE',
                    copyright: 'ajilhassanpour.com',
                    url: window.location.href,
                    directory: 'submission',
                    category: 'nuts',
                    coverage: 'Worldwide',
                    distribution: 'Global',
                    'og:title': ' محصولات | آجیل حسن پور ',
                    "og:type": 'article',
                    "og:url": window.location.href,
                    'og:image': 'https://ajilhassanpour.com/images/home-page-header/logo.png',
                    'og:site_name': 'آجیل حسن پور',
                    'og:description': 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...'
                }}>
                <Grid md={12} sm={12} xs={12}>
                    <Paper elevation={0}>
                        <Box className="titleBox">
                            <h1>{staticText.title}</h1>
                        </Box>
                        <Box
                            boxShadow={0}
                            border={0}
                            borderRadiusBottomLeft={10}
                            p={2}
                            pt={1}
                            m={1}
                            className={classes.grayBoxWithTitle}
                        >
                            <Grid container>
                                <Grid item md={6} xs={12}>
                                    <Box
                                        elevation={0}
                                        bgcolor="transparent"
                                        borderRadius={10}
                                        boxShadow={0}
                                        px={{ xs: 0, sm: 1, md: 2 }}
                                        py={3}
                                        m={1}
                                        mt={0}>
                                        <Grid container>
                                            <Grid item md={4} xs={6}>
                                                <Box color="#3b3b3b" mb={1} fontWeight="700" fontSize={16}>
                                                    <LocationOnIcon style={{ marginBottom: "-8px" }} />
                                                    &nbsp; {staticText.address}
                                                </Box>
                                            </Grid>
                                            <Grid item md={8} xs={6}>
                                                <Box color="#3b3b3b" mb={1} pt={0.4} fontSize={16}>
                                                    &nbsp; {address}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item md={4} xs={6}>
                                                <Box color="#3b3b3b" mb={1} fontWeight="700" fontSize={16}>
                                                    <AccessTimeIcon style={{ marginBottom: "-8px" }} />
                                                    &nbsp; {staticText.workTime}
                                                </Box>
                                            </Grid>
                                            <Grid item md={8} xs={6}>
                                                <Box color="#3b3b3b" mb={1} pt={0.4} fontSize={16}>
                                                    {workTime.replace('ساعت کار: ', '')}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item md={4} xs={6}>
                                                <Box color="#3b3b3b" mb={1} fontWeight="700" fontSize={16}>
                                                    <PhoneEnabledIcon style={{ marginBottom: "-8px" }} />
                                                    &nbsp; {staticText.telephone}
                                                </Box>
                                            </Grid>
                                            <Grid item md={8} xs={6}>
                                                <Box color="#3b3b3b" mb={1} pt={0.4} fontSize={16}>
                                                    {phoneNumbers}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item md={4} xs={12}>
                                                <Box color="#3b3b3b" mb={1} fontWeight="700" fontSize={16}>
                                                    <MailOutlineIcon style={{ marginBottom: "-8px" }} />
                                                    &nbsp; {staticText.email}
                                                </Box>
                                            </Grid>
                                            <Grid item md={8} xs={6}>
                                                <Box color="#3b3b3b" mb={1} pt={0.4} className={classes.emailC} fontSize={16}>
                                                    {email}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Box elevation={1} boxShadow={1} mt={1} borderRadius={10}>
                                            <a target="_blank" href="https://goo.gl/maps/EnSn1uHMnzhEja4u8">
                                                <img width="100%" alt="map" src="/images/ajilhassanpour-on-Map.jpg" />
                                            </a>

                                        </Box>

                                    </Box>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Box
                                        elevation={1}
                                        boxShadow={2}
                                        bgcolor="#fff"
                                        borderRadius={10}
                                        className={classes.formC}
                                        py={3}
                                        m={1}>
                                        <Formik
                                            style={{ width: "100%" }}
                                            initialValues={{
                                                FullName: "",
                                                MobileNumber: "",
                                                Text: "",
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={(values) => {
                                                let formData = new FormData();
                                                Object.keys(values).forEach(function eachKey(key) {
                                                    formData.append(key, values[key]);
                                                });

                                                dispatch(sendContactData(formData)).then(() =>
                                                    toggleOpenAlert("success", 'پیام شما با موفقیت ارسال شد.')
                                                );
                                            }}
                                            render={({
                                                handleSubmit,
                                                handleChange,
                                                handleBlur,
                                                values,
                                                touched,
                                                errors,
                                                setFieldValue,
                                            }) => (
                                                <form onSubmit={handleSubmit}>
                                                    <Grid container>
                                                        <Grid item md={6} xs={12}>
                                                            <Box className={classes.padding16OnDesktop}>
                                                                <lable className={classes.label}>{staticText.fullname}</lable>
                                                                <TextField
                                                                    fullWidth
                                                                    name="FullName"
                                                                    variant="outlined"
                                                                    value={values.FullName}
                                                                    onChange={handleChange}
                                                                    error={
                                                                        touched.FullName && Boolean(errors.FullName)
                                                                    }
                                                                    helperText={
                                                                        touched.FullName && errors.FullName
                                                                    }
                                                                />
                                                            </Box>
                                                        </Grid>
                                                        <Grid item md={6} xs={12}>
                                                            <Box className={classes.padding16OnDesktop}>
                                                                <lable className={classes.label}>{staticText.tel}</lable>
                                                                <TextField
                                                                    fullWidth
                                                                    name="MobileNumber"
                                                                    variant="outlined"
                                                                    value={values.MobileNumber}
                                                                    onChange={handleChange}
                                                                    error={
                                                                        touched.MobileNumber &&
                                                                        Boolean(errors.MobileNumber)
                                                                    }
                                                                    helperText={
                                                                        touched.MobileNumber && errors.MobileNumber
                                                                    }
                                                                />
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box className={classes.padding16OnDesktop}>
                                                                <lable className={classes.label}>{staticText.msg}</lable>
                                                                <TextField
                                                                    multiline
                                                                    rows={9}
                                                                    fullWidth
                                                                    name="Text"
                                                                    variant="outlined"
                                                                    value={values.Text}
                                                                    onChange={handleChange}
                                                                    error={touched.Text && Boolean(errors.Text)}
                                                                    helperText={touched.Text && errors.Text}
                                                                />

                                                                <Box pt={1}>
                                                                    {staticText.limit}
                                                                    &nbsp;<span>{"(160/" + values.Text.length + ")"}</span>
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    <Box textAlign="right" mb={1}>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            className={classes.green}>
                                                            {staticText.send}
                                                        </Button>
                                                    </Box>
                                                </form>
                                            )}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
                <Snackbar
                    open={alert.open}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={toggleCloseAlert}
                >
                    <Alert onClose={toggleCloseAlert} severity={alert.type}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </WideLayout>
        </>
    );
};

ContactUs.propTypes = {
    lang: PropTypes.string,
};

export default ContactUs;
